<div class="card card-custom panel-complementario">
	<ul class="nav nav-tabs panel-complementario__tabs" role="tablist">
		<li class="nav-item">
			<a id="tour-tab-referencias" class="nav-link" [class.active]="expanded && activeTab === 'referencias'" href="javascript:void(0)" (click)="selectTab('referencias')">Referencias</a>
		</li>
		<li class="nav-item" *ngIf="showComisiones">
			<a id="tour-tab-comisiones" class="nav-link" [class.active]="expanded && activeTab === 'comisiones'" href="javascript:void(0)" (click)="selectTab('comisiones')">Comisiones y otros cargos</a>
		</li>
		<li class="nav-item" *ngIf="showTipoNota">
			<a id="tour-tab-tipo-nota" class="nav-link" [class.active]="expanded && activeTab === 'tipo'" href="javascript:void(0)" (click)="selectTab('tipo')">Tipo de nota</a>
		</li>
		<li class="nav-item" *ngIf="mostrarPestanaTransporte">
			<a id="tour-tab-transporte" class="nav-link" [class.active]="expanded && activeTab === 'transporte'" href="javascript:void(0)" (click)="selectTab('transporte')">Transporte</a>
		</li>
		<li class="nav-item">
			<a id="tour-tab-observaciones" class="nav-link" [class.active]="expanded && activeTab === 'observaciones'" href="javascript:void(0)" (click)="selectTab('observaciones')">Observaciones</a>
		</li>
		<li class="nav-item" *ngIf="showOpciones">
			<a id="tour-tab-opciones" class="nav-link" [class.active]="expanded && activeTab === 'opciones'" href="javascript:void(0)" (click)="selectTab('opciones')">Opciones adicionales</a>
		</li>
	</ul>
</div>
